import { createSharedComposable } from "@vueuse/core";
import { ref } from "#imports";
export const useTableStore = createSharedComposable(() => {
  const showInfo = ref(true);
  return {
    showInfo
  };
});
